import { StepPathType, SectionWidth } from "../shared";

export const stepsPaths: StepPathType[] = ["dimensions", "sections", "items", "colors", "view", "specification"];

export const SECTION_SIZES: SectionWidth[] = [480, 600, 800];

export const TEMP_PROJECT = 'TEMP_PROJECT' //localStorage временное хранилище для загружаемого проекта
